function scrollCenter (el, target) { // 滚动居中
  if (!(el && target)) return
  // 获取父元素距离左侧和顶部距离
  const parentLeft = Math.floor(el.offsetWidth / 2 + el.offsetLeft)
  const parentTop = Math.floor(el.offsetHeight / 2 + el.offsetTop)
  // 获取子元素距离左侧和顶部距离
  const childLeft = Math.floor(target.offsetWidth / 2 + target.offsetLeft)
  const childTop = Math.floor(target.offsetHeight / 2 + target.offsetTop)
  const left = childLeft - parentLeft - el.scrollLeft
  const top = childTop - parentTop - el.scrollTop
  el.scrollBy({ left, behavior: 'smooth' })
}

export const vscrollCenter = {
  componentUpdated (el, binding) {
    const { value= 0} = binding
    const nodes = Array.from(el.childNodes) || []
    scrollCenter(el, nodes[value])
  }
}